export class PosMapa {
    constructor (centerLon, centerLat, zoom){
        this.centerLon = centerLon;
        this.centerLat = centerLat;
        this.zoom = zoom
    }
}

export class Seccion{
    constructor(codigo, nombre, visores, esDeVisorInicio){
        this.codigo = codigo;
        this.nombre = nombre;
        this.visores = visores;
        this.esDeVisorInicio = esDeVisorInicio
    }
}

export class AtributosVisor{
    //Con base en la tabla config.urlConfigVisores
    constructor(codigoSeccion, codigoVisor, nombre, webMapId, centerAndZoom, nombreSeccion, infoAdicional, institucional, activo, urlTablero, esInicio, posMapa){
        //Campos OrdenSeccion se omite porque solamente se usa para el query de las secciones
        this.codigoSeccion = codigoSeccion;
        this.codigoVisor = codigoVisor;
        this.nombre = nombre;
        this.webMapId = webMapId;
        this.centerAndZoom = centerAndZoom;
        this.nombreSeccion = nombreSeccion;
        this.infoAdicional = infoAdicional;
        this.institucional = institucional;
        this.activo = activo;
        this.urlTablero = urlTablero;

        //Adicionales a los campos de la tabla de la base de datos:
        this.esInicio = esInicio; //Si corresponde al visor inicial de navegación
        this.posMapa = posMapa; //Posición del mapa segun clase PosMapa
    }
}

export class ParametrosMovil{
    static propSketchWidgetLayout = "sketchWidgetLayout";
    static propZoomWidgetLayout = "zoomWidgetLayout";
    static propZoomPosWidget = "zoomPosWidget";
    static propHomePosWidget = "homePosWidget";
    static propPrintPosWidget = "printPosWidget";
    static propCercaPosWidget = "cercaPosWidget";
    static propFiltroPosWidget = "filtroPosWidget";
    static propPopupDockPosition = "popupDockPosition";
    static propFuncSetEstilosMovil = "funcSetEstilosMovil";
    constructor(sketchWidgetLayout, zoomWidgetLayout, zoomPosWidget, homePosWidget, printPosWidget, cercaPosWidget, filtroPosWidget, popupDockPosition, funcSetEstilosMovil){
        this.sketchWidgetLayout = sketchWidgetLayout;
        this.zoomWidgetLayout = zoomWidgetLayout;
        this.zoomPosWidget = zoomPosWidget;
        this.homePosWidget = homePosWidget;
        this.printPosWidget = printPosWidget;
        this.cercaPosWidget = cercaPosWidget;
        this.filtroPosWidget = filtroPosWidget;
        this.popupDockPosition = popupDockPosition;
        this.funcSetEstilosMovil = funcSetEstilosMovil;
    }
}

export class InfoLayer{
    constructor(id, urlServicio, urlDescarga, nombre, items, visible){
        this.id = id;
        this.urlServicio = urlServicio;
        this.urlDescarga = urlDescarga;
        this.nombre = nombre;
        this.items = items;
        this.visible = visible;
    }
}

export class InfoLayerItem{
    constructor(label, valor, esUrl){
        this.label = label;
        this.valor = valor;
        this.esUrl = esUrl;
    }
}